import css from "styled-jsx/css";
import { grid } from "./constants";

export default css`
.streaming-platforms-section {
  background-color: #403F3D;
}
.streaming-platforms-section .content-container {
  margin: 0 auto;
}
.streaming-platforms-section :global(.visible-slide) {
  display:flex;
}
.streaming-platforms-section .content-container .container-button-configura {
  text-align: center;
  padding-bottom: 2rem;
}

@media screen and (max-width: ${grid.breakpoint_sm}px) {
  .streaming-platforms-section .content-container .container-button-configura {
    padding-bottom: 1.5rem;
  }
  .streaming-platforms-section .content-container .container-button-configura :global(.button-configura) {
    min-width: 100%;
  }
}
`;
